import './index.scss'
import React, {useEffect, useRef, useState} from "react";
import {Header} from "../../../../components";
import Library from "../../../../library";
import {Toast} from "antd-mobile";
import {useHistory} from "react-router-dom";
import SyntheticConfirmModal from "../components/syntheticConfirmModal";
import NFTModal from "../../womenDay/components/NFTModal";

const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram()

const SyntheticPage = () => {
  const history = useHistory();
  const pageDom = useRef(null);
  const { clientId, openId, imageList: imageListParam, blessingList: blessingListParam } = Library.Util.url.paramsToObj();
  const [userInfo, setUserInfo] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedBlessing, setSelectedBlessing] = useState(null);

  // 从 URL 解析形象图和祝福图列表（由 home 跳转时传入）
  const imageList = React.useMemo(() => {
    if (!imageListParam) return [];
    try {
      const parsed = JSON.parse(decodeURIComponent(imageListParam));
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [imageListParam]);

  const blessingList = React.useMemo(() => {
    if (!blessingListParam) return [];
    try {
      const parsed = JSON.parse(decodeURIComponent(blessingListParam));
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [blessingListParam]);

  useEffect(() => {
    JsBridge.getCurrentUserInfo().then(setUserInfo).catch(() => {});
  }, []);

  const handleImageSelect = (index) => {
    console.log('点击形象图:', index, imageList[index]);
    if (imageList[index]?.count > 0) {
      setSelectedImage(selectedImage === index ? null : index);
      console.log('选中状态:', selectedImage === index ? null : index);
    } else {
      console.log('该碎片数量为0，无法选择');
    }
  };

  const handleBlessingSelect = (index) => {
    console.log('点击祝福图:', index, blessingList[index]);
    if (blessingList[index]?.count > 0) {
      setSelectedBlessing(selectedBlessing === index ? null : index);
      console.log('选中状态:', selectedBlessing === index ? null : index);
    } else {
      console.log('该碎片数量为0，无法选择');
    }
  };

  const handleSynthetic = async () => {
    if (selectedImage === null || selectedBlessing === null) {
      Toast.show('请选择形象图和祝福图');
      return;
    }
    // 显示确认弹窗
    const ModalInstance = NFTModal.show({
      content: <SyntheticConfirmModal
        onClose={() => {
          if (ModalInstance) {
            ModalInstance.close();
          }
        }}
        successCallBack={() => {
          if (ModalInstance) {
            ModalInstance.close();
          }
          setSelectedImage(null);
          setSelectedBlessing(null);
          if (window.JsBridge.hasWebViewBridge()) {
            window.JsBridge.back();
          } else {
              window.history.go(-1);
          }
        }}
        clientId={isMiniprogram ? clientId : userInfo?.clientId}
        miniOpenId={isMiniprogram && openId && openId !== 'undefined' && openId !== null ? openId :null}
        imgCode={imageList[selectedImage]?.type}
        wordCode={blessingList[selectedBlessing]?.type}
      />,
      getContainer: pageDom.current,
    });
  };

  const toSyntheticList = () => {
    const query = [clientId && `clientId=${encodeURIComponent(clientId)}`, openId && `openId=${encodeURIComponent(openId)}`].filter(Boolean).join('&');
    const uri = `/front/activities/fragmentsSyntheticMa/syntheticList${query ? `?${query}` : ''}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` });
    } else {
      history.push(uri);
    }
  };

  return (
    <div className="syntheticListPage2" ref={pageDom}>
      <div>
        <Header midText="" bgColor={'#F8F8F8'}/>
      </div>
      <div className="body-container">
        {/* 请选择形象 */}
        <div className="select-section">
          <div className="section-title">请选择形象</div>
          <div className="fragments-grid">
            {imageList.map((item, index) => (
              <div 
                key={index} 
                className={`fragment-item ${selectedImage === index ? 'selected' : ''} ${item?.count === 0 ? 'disabled' : ''}`}
                onClick={() => handleImageSelect(index)}
              >
                {selectedImage === index && <div className="overlay"></div>}
                <div className={`checkbox ${selectedImage === index ? 'checked' : ''}`}>
                  {selectedImage === index && <span className="checkmark">✓</span>}
                </div>
                <img src={item.imgUrl} alt="" style={{ filter: item?.count > 0 ? '' : 'grayscale(100%)'}}/>
                <div className="numTag">{item?.count || 0}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 请选择祝福语 */}
        <div className="select-section">
          <div className="section-title">请选择祝福语</div>
          <div className="fragments-grid">
            {blessingList.map((item, index) => (
              <div 
                key={index} 
                className={`fragment-item ${selectedBlessing === index ? 'selected' : ''} ${item?.count === 0 ? 'disabled' : ''}`}
                onClick={() => handleBlessingSelect(index)}
              >
                {selectedBlessing === index && <div className="overlay"></div>}
                <div className={`checkbox ${selectedBlessing === index ? 'checked' : ''}`}>
                  {selectedBlessing === index && <span className="checkmark">✓</span>}
                </div>
                <img src={item.imgUrl} alt="" style={{ filter: item?.count > 0 ? '' : 'grayscale(100%)'}}/>
                <div className="numTag">{item?.count || 0}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 按钮区域 */}
        <div className="button-area">
          <button 
            className="synthetic-btn"
            onClick={handleSynthetic}
            disabled={selectedImage === null || selectedBlessing === null}
          >
            合成为藏品
          </button>
          <div className="record-link" onClick={toSyntheticList}>
            合成记录&gt;
          </div>
        </div>
      </div>
    </div>
  )
}
export default SyntheticPage